import { GraphQLClient } from "graphql-request";

import {
  IMPERSONATE_GRAPHQL_PATH,
  isImpersonationToken,
} from "@/lib/impersonation";
import {
  isStaffAccountToken,
  hasuraClaimsFromToken,
  LEARNER_ACCOUNT_GRAPHQL_PATH,
} from "@/lib/staff-account-role";

export function createClient(token?: string | null) {
  if (isImpersonationToken(token)) {
    return new GraphQLClient(IMPERSONATE_GRAPHQL_PATH);
  }

  if (token && isStaffAccountToken(token)) {
    return new GraphQLClient(LEARNER_ACCOUNT_GRAPHQL_PATH);
  }

  const claims = token ? hasuraClaimsFromToken(token) : null;
  const organization = claims?.["x-hasura-organization-id"] ?? claims?.["x-hasura-organization"] ?? process.env.NEXT_PUBLIC_ORGANIZATION_ID;
  return new GraphQLClient(process.env.NEXT_PUBLIC_API_URL!, {
    headers: {
      authorization: `Bearer ${token}`,
      ...(organization ? {"x-hasura-organization-id": organization} : {}),
    },
  });
}
